<div class="Chart">
  <div
    class="Chart__ChartWrapper"
    [ngClass]="{ 'Chart__ChartWrapper--Bar': isBar }"
  >
    <canvas id="myChart" #myChart></canvas>
  </div>
</div>
